// Google AutoComplete Address Lookup

$(document).ready(function () {

  let autocomplete;
  let addressField;

  // Create the autocomplete object, restricting the search predictions to addresses in the UK.
  addressField = document.querySelector("#address");
  autocomplete = new google.maps.places.Autocomplete(addressField, {
    componentRestrictions: { country: ["uk"] },
    fields: ["address_components"],
    types: ["address"],
  });
  autocomplete.addListener("place_changed", fillInAddress);

  // When the user selects an address from the drop-down, populate the address fields in the form.
  function fillInAddress() {
    // Get the place details from the autocomplete object.
    const place = autocomplete.getPlace();

    let address1 = "";
    let postcode = "";

    // Get each component of the address from the place details,
    // and then fill-in the corresponding field on the form.
    // place.address_components are google.maps.GeocoderAddressComponent objects
    // which are documented at http://goo.gle/3l5i5Mr
    for (const component of place.address_components) {
      const componentType = component.types[0];
      switch (componentType) {
        case "country": {
          $("#country").val(component.short_name);
          break;
        }
        case "street_number": {
          address1 = `${component.long_name} ${address1}`;
          break;
        }
        case "route": {
          address1 += component.short_name;
          break;
        }

        case "postal_town": {
          $("#city").val(component.long_name);
          break;
        }

        case "postal_code": {
          postcode = `${component.long_name}${postcode}`;
          break;
        }

        case "postal_code_suffix": {
          postcode = `${postcode}-${component.long_name}`;
          break;
        }
      }
    }
    $("#address").val(address1);
    $("#postcode").val(postcode);

    // Check for Northern Ireland address
    checkNIAddress(postcode.substring(0, 2));
  }

  /*
   * I check for specific locations where we need to apply a shipping rate premium
   */
  function checkNIAddress(pcPrefix) {
    if (pcPrefix == "BT") {
      alert(
        "It looks like you've selected a delivery address in Northern Ireland. Shipping will be £13.14 (£10.95 ex VAT) per item and delivery takes 2 working days.",
      );
    }
  }
});
